module.exports = __webpack_public_path__ + "static/media/sort-numeric-up-alt.b4a0b1d6.svg";